// extracted by mini-css-extract-plugin
export default {"carousel_img":"Carousel_carousel_img__vJ4Si","carousel_container":"Carousel_carousel_container__-OOJW"};